class RoSizeGuideButton extends HTMLElement {
  constructor() {
    super();

    this.handleClick = () => {
      const sizeGuide = this.findSizeGuide();
      if (sizeGuide && typeof sizeGuide.open === 'function') {
        sizeGuide.open();
        return;
      }
      publish(PUB_SUB_EVENTS.sizeGuideRequested);
    };
  }

  /**
   * Size guide for this picker: inside the same product panel (Shop the look) or PDP sibling after `ro-product-info`.
   * @returns {HTMLElement | null}
   */
  findSizeGuide() {
    const productInfo = this.closest('ro-product-info');
    if (productInfo) {
      const insideGuide = productInfo.querySelector('ro-size-guide');
      if (insideGuide) return insideGuide;

      let sibling = productInfo.nextElementSibling;
      while (sibling) {
        if (sibling.matches?.('ro-size-guide')) return sibling;
        sibling = sibling.nextElementSibling;
      }
    }

    const panelHost = this.closest('[data-runway-panel], .quick-add-section');
    return panelHost?.querySelector('ro-size-guide') ?? null;
  }

  connectedCallback() {
    this.button = this.querySelector('button');

    if (!this.button) {
      console.error('No button element found inside ro-size-guide-button');
      return;
    }

    this.button.addEventListener('click', this.handleClick);
    this.syncDisabledState();
    queueMicrotask(() => this.syncDisabledState());
  }

  /** Enables the trigger when a scoped size guide exists for this product. */
  syncDisabledState() {
    if (!this.button) return;
    this.button.disabled = !this.findSizeGuide();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }
}

if (!customElements.get('ro-size-guide-button')) {
  customElements.define('ro-size-guide-button', RoSizeGuideButton);
}
